import { FETCH_NEW_ORDERS } from '../actions/types';
export default function (state={},action) {
    switch (action.type){
        case FETCH_NEW_ORDERS:
            return action.payload || false;
        default:
            return state;
    }
}